import { Modal } from '@faststore/ui'
import loadable from '@loadable/component'
import React, { useState, useEffect } from 'react'

import { HAS_WINDOW } from '../../../constants'
import { useClubContext } from '../../../contexts/ClubContext'
import { useLocalStorageContext } from '../../../contexts/LocalStorageContext'
import { useRegionalizationContext } from '../../../contexts/RegionalizationContext'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useAnalyticsEvents } from '../../../hooks/useAnalyticsEvents'
import { useUI } from '../../../sdk/ui/Provider'

const ClubModalBeExclusiveClient = loadable(
  () => import('../ClubModals/ClubModalBeExclusiveClient')
)

const CartSidebar = loadable(() => import('../../cart/CartSidebar'))

const RegionalizationModal = loadable(
  () => import('../Header/components/Regionalization/RegionalizationModal')
)

const CookiesModal = loadable(() => import('../CookiesModal'))

const CommonModalRender = () => {
  const [openClubModal, setOpenClubModal] = useState(false)

  const { cart: openMiniCart } = useUI()
  const { getLocalStorage, setLocalStorage } = useLocalStorageContext()
  const { openRegionModal } = useRegionalizationContext()
  const { userInfos, isClubClient } = useClubContext()
  const { hasClubRegister } = useStoreContext()
  const { genericTaggingEvent } = useAnalyticsEvents()

  useEffect(() => {
    if (!HAS_WINDOW) {
      return
    }

    const isNotClubClient =
      userInfos?.email &&
      userInfos?.isLoggedIn &&
      hasClubRegister &&
      !isClubClient

    const isNotClubInfoPage = !location.pathname.includes('/club-informacao')

    const lastSession = getLocalStorage?.('login-success-session-id')

    if (userInfos?.sessionId && lastSession !== userInfos.sessionId) {
      genericTaggingEvent('login-success', {
        sessionId: userInfos.sessionId,
        isClubClient,
        mensagem: 'usuario logado com sucesso',
      })

      setLocalStorage?.('login-success-session-id', userInfos.sessionId)
    }

    if (isNotClubClient && isNotClubInfoPage) {
      setOpenClubModal(true)
      document.body.style.overflowY = 'hidden'
    }
  }, [userInfos])

  return (
    <>
      {openClubModal && (
        <Modal isOpen className="club-modal">
          <ClubModalBeExclusiveClient />
        </Modal>
      )}

      {openMiniCart && <CartSidebar />}

      {openRegionModal && (
        <Modal isOpen className="modal-regionalization">
          <RegionalizationModal />
        </Modal>
      )}

      <CookiesModal />
    </>
  )
}

export default CommonModalRender
